import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import _ from 'lodash';
import { teacherFetchStudentMissions, } from '../../services/studentMissions.service';
import StudentReport from '../admin/components/StudentReport.js';
import { usePDF } from 'react-to-pdf';

function Component(props) {
    const { id } = useParams();
    const navigate = useNavigate();
    const [mission, setmission] = useState(null)
    const [isLoading, setisLoading] = useState(false)

    const fetchMission = async () => {
        let result = await teacherFetchStudentMissions(props.token.token, { _id: id });
        if (result.result) {
            setmission(result.result?.[0] || null)
        } else {
            alert('Fetch data error')
        }
    }

    const refresh = async () => {
        if (isLoading) return
        setisLoading(true)
        await fetchMission()
        setisLoading(false)
    }

    useEffect(() => {
        refresh()
    }, [id])

    const { toPDF, targetRef } = usePDF({ filename: `${mission?.student?.name}-閱讀成績單.pdf` });


    return (
        <div className='relative h-full flex-1 bg-[#F2F2F2] flex-col flex text-[16px] text-[black]' style={{ overflowY: "auto" }}>
            <div className='flex flex-row items-center justify-between items-center gap-[8px] flex-wrap px-[16px] pt-[16px] mb-[8px]'>
                <div className='text-[#1D1D41] text-[24px] font-[400] cursor-pointer' onClick={() => { navigate(`/platform/results/${mission?.missionId}`) }}>{`<`} 返回</div>

                <button className='text-[blue] text-[12px] underline' onClick={() => toPDF()}>下載閱讀成績單</button>
            </div>
            <div ref={targetRef} className='w-full'>
                <StudentReport mission={mission} />
            </div>
        </div>
    )

}

export default connect((store) => {
    return {
        token: store.tokenReducer,
    }
})(Component)
